module.exports = __webpack_public_path__ + "static/Gotham-BlackIta-ec6b35b07448e1624cb09323b5fb6e32.otf";